/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type DashboardPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const dashboardPanelEntryPoint: EntryPoint<DashboardPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<DashboardPanelEntryPointComponent>(
			/* webpackChunkName: "async-itam-ham-dashboard-panel", jiraSpaEntry: "async-itam-ham-dashboard-panel" */ './DashboardPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
